import { clientEnv } from '@/config/env/client';
import { getCookieByName } from '@/utils/cookies';

type GoogleBusinessCookie = {
  _rwg_token: string;
  _merchant_id: string;
};

export const storeGoogleBusinessCookie = (merchantId: string) => {
  const urlParams = new URLSearchParams(window?.location?.search);
  const rwgTokenEncoded = urlParams.get('rwg_token');
  if (!rwgTokenEncoded) return;
  const rwgToken =
    rwgTokenEncoded === 'test' && clientEnv.NEXT_PUBLIC_GOOGLE_BUSINESS_TOKEN_TEST
      ? clientEnv.NEXT_PUBLIC_GOOGLE_BUSINESS_TOKEN_TEST
      : decodeURIComponent(rwgTokenEncoded!);
  const rwgCookie = JSON.stringify({ _rwg_token: rwgToken, _merchant_id: merchantId });
  if (typeof window !== 'undefined') {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    document.cookie = `rwg=${rwgCookie}; expires=${expirationDate.toUTCString()}; path=/; samesite=strict`;
  }
};

export const expireGoogleBusinessCookie = () => {
  if (typeof window !== 'undefined') {
    document.cookie = `rwg=''; expires=expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; samesite=strict`;
  }
};

export const getStoreGoogleBusinessCookie = () => {
  try {
    const gbCookie = JSON.parse(getCookieByName('rwg') || '');
    return gbCookie._rwg_token ? (gbCookie as GoogleBusinessCookie) : undefined;
  } catch (err) {
    return undefined;
  }
};

export const sendGoogleBusinessConversion = async (checkoutMerchantId: string) => {
  const googleCookie = getStoreGoogleBusinessCookie() as GoogleBusinessCookie | undefined;
  const googleConversionUrl = clientEnv.NEXT_PUBLIC_GOOGLE_CONVERSION_ENDPOINT;
  const googlePartnerId = clientEnv.NEXT_PUBLIC_GOOGLE_PARTNER_ID ? parseInt(clientEnv.NEXT_PUBLIC_GOOGLE_PARTNER_ID) : '';

  if (!googleCookie || !googleConversionUrl || !googlePartnerId) return;
  const merchantChanged = checkoutMerchantId === googleCookie._merchant_id ? 2 : 1;
  try {
    await fetch(googleConversionUrl, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      mode: 'no-cors',
      method: 'POST',
      body: JSON.stringify({
        conversion_partner_id: googlePartnerId,
        rwg_token: googleCookie._rwg_token,
        merchant_changed: merchantChanged,
      }),
    });
  } catch (err) {
    console.warn('There was an error with conversion tracking');
  }
  expireGoogleBusinessCookie();
};
